import { Stack } from "@mui/material";
import type { ReactNode } from "react";

/** Stack interno das ações mobile (dentro do shell do card). */
export function EhrMobileActionStack({ children }: { children: ReactNode }) {
  return (
    <Stack spacing={0.75} sx={{ px: 1.15, py: 1.1, width: "100%" }}>
      {children}
    </Stack>
  );
}

export const ehrMobileActionBtnSx = {
  textTransform: "none",
  fontWeight: 700,
  borderRadius: 2,
  minHeight: 42,
  justifyContent: "flex-start",
  px: 1.5,
} as const;
